import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import { ReactComponent as ForwardRef } from '../../assets/icons/TriangleDown.svg.js';
import style from './Select.module.css.js';

const Select = React__default.forwardRef(({ error, errorMessage, ...attrs }, ref) => (jsxs("div", { className: classNames(style.wrapper, attrs.className), children: [jsxs("div", { className: style.innerWrapper, children: [jsx("select", { ...attrs, ref: ref, className: classNames(style.select, (error || errorMessage) && style.error), children: attrs.children }), jsx(ForwardRef, { className: style.icon })] }), errorMessage && jsx("span", { className: style.errorMessage, children: errorMessage })] })));
Select.displayName = "Select";

export { Select };
//# sourceMappingURL=Select.js.map
